import { render, staticRenderFns } from "./OSpeedSelect.vue?vue&type=template&id=31b9d83c&scoped=true&"
import script from "./OSpeedSelect.vue?vue&type=script&lang=js&"
export * from "./OSpeedSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b9d83c",
  null
  
)

export default component.exports